export default {
  state: {
    systemTitle: "外星人淘宝接入系统",
    userId: 0,
    userName: '',
    nickName: '',
    balance: '',
    isMobile: false,
    verision: "v1.0",
    isFullScreen: false,
    keepLiveRoute: [],
    routeShow: true
  },
  mutations: {
    setFullScreen(state, val){
      state.isFullScreen = val
    },
    setMobile(state, val){
      state.isMobile = val
    },
    setUserInfo(state, val){
      state.userId = val.id;
      state.userName = val.username;
      state.nickName = val.nickname;
      state.balance = val.balance;
    },
    setRouteShow(state, val){
      state.routeShow = val;
    }
  },
  actions:{
    
  }
}